import React, { FC, memo, ReactNode } from 'react';

import { HeaderBarStyled } from './styles';

interface Props {
  children?: ReactNode;
}

const HeaderBar: FC<Props> = ({ children}) => (
  <HeaderBarStyled>
    {children}
  </HeaderBarStyled>
);

export default memo(HeaderBar);
